import React from 'react';
const ServiceCoveragePage = () => {
  return <div className="container mx-auto px-4 py-12" data-id="element-356">
      <h1 className="text-3xl font-bold mb-8 text-[#1A2B4C]" data-id="element-357">
        Service Coverage
      </h1>
      <div className="bg-white rounded-lg shadow-sm p-8" data-id="element-358">
        <h2 className="text-xl font-bold mb-4 text-[#1A2B4C]" data-id="element-359">
          Service Activation & Coverage
        </h2>
        <p className="mb-6" data-id="element-360">
          Your cover starts as soon as your payment is processed. You will
          receive a confirmation email within minutes. There's no need to do
          anything to activate your plan; it's an automatic process. Your
          coverage will remain active for 12 months from the date of purchase.
          <br data-id="element-361" />
          <br data-id="element-362" />
          Your plan expires at 23:59 exactly one year after the purchase date
          unless you choose to renew it beforehand.
        </p>
        <h2 className="text-xl font-bold mb-4 text-[#1A2B4C]" data-id="element-363">
          Requesting a Repair
        </h2>
        <p className="mb-6" data-id="element-364">
          If you need a repair, simply contact our team using the details below.
          We typically arrange engineer appointments within 24 to 48 hours of
          you reporting the fault, excluding weekends and public holidays.
          <br data-id="element-365" />
          <br data-id="element-366" />
          Phone: 0800 055 4969
          <br data-id="element-367" />
          Email: dronakoirala6@gmail.com
        </p>
        <h2 className="text-xl font-bold mb-4 text-[#1A2B4C]" data-id="element-368">
          What Your Plan Covers
        </h2>
        <ul className="list-disc pl-6 mb-6" data-id="element-369">
          <li className="mb-2" data-id="element-370">
            Unlimited repairs and call-outs for any covered appliance during
            your 12-month plan.
          </li>
          <li className="mb-2" data-id="element-371">
            All labour costs for our qualified engineers.
          </li>
          <li className="mb-2" data-id="element-372">
            Replacement parts when they are needed and available.
          </li>
          <li className="mb-2" data-id="element-373">
            Coverage for all mechanical and electrical faults.
          </li>
        </ul>
        <h2 className="text-xl font-bold mb-4 text-[#1A2B4C]" data-id="element-374">
          What Your Plan Does Not Cover
        </h2>
        <p className="mb-2" data-id="element-375">
          For fairness and clarity, please be aware that the following are not
          covered under your plan:
        </p>
        <ul className="list-disc pl-6 mb-6" data-id="element-376">
          <li className="mb-2" data-id="element-377">Cosmetic damage or normal wear and tear.</li>
          <li className="mb-2" data-id="element-378">
            Any faults that existed before your plan started.
          </li>
          <li className="mb-2" data-id="element-379">
            Damage caused by misuse, neglect, or unauthorised repairs.
          </li>
          <li className="mb-2" data-id="element-380">
            Appliances that are over ten years old at the start of the plan.
          </li>
          <li className="mb-2" data-id="element-381">
            Damage caused by floods, fires, or other natural disasters.
          </li>
          <li className="mb-2" data-id="element-382">
            Appliances not used in line with the manufacturer's guidelines.
          </li>
        </ul>
        <p className="mb-6" data-id="element-383">
          If any of these conditions apply, your plan may be cancelled without a
          refund.
        </p>
        <h2 className="text-xl font-bold mb-4 text-[#1A2B4C]" data-id="element-384">Service Area</h2>
        <p className="mb-4" data-id="element-385">
          We provide service to mainland UK postcodes. If you live in a remote
          area, response times might be longer. Please contact us to confirm
          that we cover your specific location.
        </p>
      </div>
    </div>;
};
export default ServiceCoveragePage;